import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import { DialogTitle } from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';
import Checkbox from 'material-ui/Checkbox';
import Button from '../../Parts/Button';
import Typography from 'material-ui/Typography';
import { generateCapSizePerCorporationMenu } from '../../../utils/utils'
import { capSortMenu } from '../../../constants/SidebarValues';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import MenuItem from 'material-ui/Menu/MenuItem';

const styles = () => ({
  paper: {
    background: "#F4F6F9",
    width: '45%',
    maxHeight: 'unset',
  },

  contentContainer: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  sectionContainers: {
    width: '100%',
    boxSizing: 'border-box',
  },

  guttersContainer: {
    width: '45%',
    zIndex: 2,
    top: 60,
    position: 'fixed',
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    borderBottom: "1px solid #D8DBDF",
    width: '100%',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },

  dialogTitle: {
    padding: '0px',
    flex: 1,
  },

  containerWrapper: {
    width: '100%',
    padding: '55px 25px 25px 25px',
    boxSizing: 'border-box',
  },

  sectionContainer: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },

  notification: {
    marginTop: '30px',
    color: '#71737B',
    border: '1px solid #D8DBDF',
    background: '#ECEEF0',
    borderRadius: '2px',
    padding: '20px',
    marginBottom: '30px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  sectionTitle: {
    paddingTop: '30px',
    fontSize: "13px",
    fontWeight: 700,
  },

  sectionDesc: {
    paddingTop: '20px',
    fontSize: "12px",
  },

  sectionContent: {
    marginTop: '20px',
  },

  capSizePerCorporationMenu: {
    background: "#FFFFFF",
    padding: '20px',
    border: '#D9DBDF'
  },

  capSizePerCorporationRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  capListCountLabel: {
    marginLeft: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },

  preferredContainer: {
    display: 'flex',
  },

  preferredLabel: {
    width: '100px',
    fontSize: '14px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  buttonContainer: {
    marginTop: '30px',
  },
});

const capSizePerCorporationMenu = generateCapSizePerCorporationMenu();

class SelectCapSizeFilterDialog extends React.Component {
  initialState = {
    cap_size_per_corporation: "0",
    cap_sort_first_preferred: "0",
    cap_sort_second_preferred: "0",
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentWillMount() {
    this.setState({
      cap_size_per_corporation: this.props.set_cap_size_per_corporation,
      cap_sort_first_preferred: this.props.set_cap_sort_first_preferred,
      cap_sort_second_preferred: this.props.set_cap_sort_second_preferred,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.cap_size_per_corporation === nextProps.set_cap_size_per_corporation) {
      this.setState({
        cap_size_per_corporation: nextProps.set_cap_size_per_corporation,
      });
    }
    if (this.state.cap_sort_first_preferred === nextProps.set_cap_sort_first_preferred) {
      this.setState({
        cap_sort_first_preferred: nextProps.set_cap_sort_first_preferred,
      });
    }
    if (this.state.cap_sort_second_preferred === nextProps.set_cap_sort_second_preferred) {
      this.setState({
        cap_sort_second_preferred: nextProps.set_cap_sort_second_preferred,
      });
    }
  }

  handleScroll = () => {
    const maxScrollTop = 20;
    if (this.contentRef && this.titleRef && this.contentRef.scrollTop > maxScrollTop) {
      this.titleRef.style.boxShadow = '0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
    } else {
      this.titleRef.style.boxShadow = 'none'
    }
  }

  setTitleRef = (node) => {
    this.titleRef = node;
  }

  setContentRef = (node) => {
    this.contentRef = node;
    if (this.contentRef) {
      this.contentRef.addEventListener('scroll', this.handleScroll, false);
    }
  }

  selectSizePerCorporation = value => () => {
    let cap_size_per_corporation = this.state.cap_size_per_corporation;

    this.setState({
      cap_size_per_corporation: cap_size_per_corporation === value ? "0" : value
    })
  }

  handleSortPreferredChange = (property) => e => {
    if (property === 'cap_sort_first_preferred' && this.state.cap_sort_first_preferred !== e.target.value) {
      this.setState({
        'cap_sort_second_preferred': "0",
      })
    }
    this.setState({
      [property]: e.target.value,
    })
  }

  render() {
    const { classes, toggleDialog, isOpen } = this.props;
    const { cap_size_per_corporation, cap_sort_first_preferred, cap_sort_second_preferred } = this.state;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div ref={this.setTitleRef} className={classes.guttersContainer}>
          <Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              1企業につき表示する人数を制限する
            </DialogTitle>
          </Toolbar>
        </div>

        <div className={classes.containerWrapper} ref={this.setContentRef}>
          <div className={classes.sectionContainers}>
            <div className={classes.sectionContainer}>
              <div className={classes.sectionTitle}>表示する人数を選択してください</div>
              <div className={classes.sectionContent}>
                <div className={classes.capSizePerCorporationMenu}>
                  {capSizePerCorporationMenu.map((item, i) => (
                    <div className={classes.capSizePerCorporationRow} key={i} style={{ marginTop: i === 0 ? '0px' : '8px' }}>
                      <Checkbox
                        color="primary"
                        checked={cap_size_per_corporation === item.value}
                        onChange={this.selectSizePerCorporation(item.value.toString())}
                        style={{
                          width: "20px",
                          height: "20px",
                        }}
                        value={item.value.toString()}
                      />
                      <Typography
                        variant="subheading"
                        className={classes.capListCountLabel}
                        style={{ color: "#181819" }}
                        onClick={this.selectSizePerCorporation(item.value.toString())}
                      >
                        {item.name}
                      </Typography>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.sectionContainer}>
              <div className={classes.sectionTitle}>どの条件で表示しますか?</div>
              <div className={classes.sectionDesc}>着任日が新しい順・役職レイヤーの高い順のどちらかもしくは、両方を選択することができます。未選択の場合はランダムで表示されます。</div>
              <div className={classes.sectionContent}>

                <div className={classes.preferredContainer}>
                  <div className={classes.preferredLabel}> 第一優先 </div>
                  <FormControl fullWidth>
                    <Select
                      value={cap_sort_first_preferred}
                      onChange={this.handleSortPreferredChange('cap_sort_first_preferred')}
                      inputProps={{
                        disableunderline: 'true',
                      }}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        }
                      }}
                      fullWidth
                      disableUnderline
                    >
                      {capSortMenu.map((item, i) => (
                        <MenuItem
                          key={Number(i)}
                          value={item.value.toString()}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </div>

              {(() => {
                if (cap_sort_first_preferred !== '0') {
                  return (
                    <div className={classes.sectionContent}>
                      <div className={classes.preferredContainer}>
                        <div className={classes.preferredLabel}> 第二優先 </div>
                        <FormControl fullWidth>
                          <Select
                            value={cap_sort_second_preferred}
                            onChange={this.handleSortPreferredChange('cap_sort_second_preferred')}
                            inputProps={{
                              disableunderline: 'true',
                            }}
                            MenuProps={{
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              }
                            }}
                            fullWidth
                            disableUnderline
                          >
                            {capSortMenu.filter(item => item.value !== cap_sort_first_preferred).map((item) => {
                              return (
                                <MenuItem
                                  key={Number(item.value)}
                                  value={item.value.toString()}>
                                  {item.name}
                                </MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  )
                }
              })()}

            </div>
            <div className={classes.notification}>一度に検索できる該当企業数は50000件以下となっております。他の検索条件と合わせて検索してください。</div>
            <div className={classes.buttonContainer}>
              <Button
                handleClickButton={() => {
                  this.props.saveCapSizePerCorporation(cap_size_per_corporation)
                  this.props.savaCapSortFirstPreferred(cap_sort_first_preferred)
                  this.props.savaCapSortSecondPreferred(cap_sort_second_preferred)
                  toggleDialog()
                }}
                text="この条件をセット"
                size="large"
                style={{ width: "100%" }}
                disabled={
                  this.state.cap_size_per_corporation === this.props.set_cap_size_per_corporation &&
                  this.state.cap_sort_first_preferred === this.props.set_cap_sort_first_preferred &&
                  this.state.cap_sort_second_preferred === this.props.set_cap_sort_second_preferred
                }
              />
            </div>
          </div>
        </div>
      </DialogModal>
    );
  }
}

SelectCapSizeFilterDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  saveCapSizePerCorporation: PropTypes.func.isRequired,
  savaCapSortFirstPreferred: PropTypes.func.isRequired,
  savaCapSortSecondPreferred: PropTypes.func.isRequired,
  set_cap_size_per_corporation: PropTypes.string.isRequired,
  set_cap_sort_first_preferred: PropTypes.string.isRequired,
  set_cap_sort_second_preferred: PropTypes.string.isRequired,
};

export default withStyles(styles)(SelectCapSizeFilterDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/SelectCapSizeFilterDialog.jsx